module.exports = __webpack_public_path__ + "img/horizontal_1_1_r_1.0890536f.png";